/* ============================================================
   BDG BACK IN STOCK — botón "LAS QUIERO" + popup → Klaviyo BIS
   ------------------------------------------------------------
   El botón/modal BIS de main-product.liquid escuchaba el evento
   'variant:changed', que este tema nunca dispara — por eso nunca
   aparecía. Este script:
   1. Reubica el botón ARRIBA del botón AGREGAR AL CARRITO.
   2. Lo muestra/oculta según disponibilidad real de la variante
      (fuente: ProductJson-* + select[name=id], que sí dispara change).
   3. Inhabilita el ATC cuando la talla seleccionada está agotada.
      NOTA: sin atributo disabled ni MutationObserver — theme.js
      pelea por ese atributo y entra en loop. Usamos pointer-events
      + guard de submit en captura, que el tema no toca.
   4. Si el producto está 100% agotado (el tema no renderiza el
      botón/modal en ese caso), los crea dinámicamente.
   5. Suscribe el email a Klaviyo Back in Stock por variante exacta
      (producto+talla) — dispara el flow BIS de Klaviyo.
   ============================================================ */
(function () {
  'use strict';

  var BTN_TEXT = 'LAS QUIERO — NOTIFÍCAME CUANDO REGRESEN';
  var MODAL_TITLE = 'LAS QUIERES?';
  var MODAL_BODY = 'Te notificaremos por correo cuando vuelvan a estar disponibles.';
  var SUBMIT_TEXT = 'REGISTRARME EN BACK IN STOCK';
  var KLAVIYO_COMPANY = 'Q72C8S';

  function sizeLabel(v) {
    return v.option3 || v.option2 || v.option1 || v.title || '';
  }

  function soldOutText() {
    return (window.theme && window.theme.strings && window.theme.strings.products_variant_no_stock) || 'Agotado';
  }

  function modalBodyHtml(productTitle) {
    return productTitle + ' — Talla <span id="bdg-bis-size"></span><br>' + MODAL_BODY;
  }

  function buildModal(productTitle) {
    var modal = document.createElement('div');
    modal.id = 'bdg-bis-modal';
    modal.style.cssText = 'display:none;position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.55);align-items:center;justify-content:center;padding:16px;';
    modal.innerHTML =
      '<div style="background:#fff;border-radius:4px;padding:28px 24px;max-width:400px;width:100%;position:relative;font-family:var(--font-body-family,sans-serif);">' +
        '<button data-bdg-bis-close style="position:absolute;top:12px;right:14px;background:none;border:none;font-size:20px;cursor:pointer;color:#888;line-height:1;">✕</button>' +
        '<p style="font-size:11px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;margin:0 0 6px;">📩 ' + MODAL_TITLE + '</p>' +
        '<p style="font-size:13px;color:#555;margin:0 0 18px;line-height:1.5;">' + modalBodyHtml(productTitle) + '</p>' +
        '<input id="bdg-bis-email" type="email" placeholder="tu@correo.com" style="width:100%;box-sizing:border-box;border:1px solid #ddd;border-radius:3px;padding:10px 12px;font-size:14px;margin-bottom:10px;outline:none;">' +
        '<button id="bdg-bis-submit" style="width:100%;background:#111;color:#fff;border:none;border-radius:3px;padding:12px;font-size:12px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;cursor:pointer;">' + SUBMIT_TEXT + '</button>' +
        '<p id="bdg-bis-msg" style="margin:10px 0 0;font-size:12px;text-align:center;display:none;"></p>' +
      '</div>';
    return modal;
  }

  function bisSubmit() {
    var email = (document.getElementById('bdg-bis-email').value || '').trim();
    var variantId = document.getElementById('bdg-bis-btn').getAttribute('data-variant-id');
    var msg = document.getElementById('bdg-bis-msg');
    var btn = document.getElementById('bdg-bis-submit');

    if (!email || email.indexOf('@') === -1) {
      msg.style.display = 'block';
      msg.style.color = '#C72E2F';
      msg.textContent = 'Por favor ingresa un correo válido.';
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Registrando...';

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    })
    .then(function (res) {
      msg.style.display = 'block';
      if (res.status === 202 || res.status === 200 || res.status === 204) {
        msg.style.color = '#1B9500';
        msg.textContent = '¡Listo! Te avisamos cuando vuelva.';
        btn.textContent = '✓ Registrada';
      } else {
        msg.style.color = '#C72E2F';
        msg.textContent = 'Hubo un error. Intenta de nuevo.';
        btn.disabled = false;
        btn.textContent = SUBMIT_TEXT;
      }
    })
    .catch(function () {
      msg.style.display = 'block';
      msg.style.color = '#C72E2F';
      msg.textContent = 'Hubo un error. Intenta de nuevo.';
      btn.disabled = false;
      btn.textContent = SUBMIT_TEXT;
    });
  }

  function init() {
    var form = document.querySelector('.product-detail .product-purchase-form') ||
               document.querySelector('.product-purchase-form');
    if (!form) return;
    var atc = form.querySelector('.button[type="submit"]');
    if (!atc) return;
    var sel = form.querySelector('select[name="id"], input[name="id"]');

    // ---------- datos de variantes ----------
    var productData = null;
    var pjs = document.querySelectorAll('script[id^="ProductJson-"]');
    for (var i = 0; i < pjs.length; i++) {
      try {
        var d = JSON.parse(pjs[i].textContent);
        if (d && d.variants) { productData = d; break; }
      } catch (err) {}
    }
    var variants = productData ? productData.variants : [];
    if (!variants.length) return;

    function findVariant(id) {
      id = String(id);
      for (var j = 0; j < variants.length; j++) {
        if (String(variants[j].id) === id) return variants[j];
      }
      return null;
    }

    var allOOS = variants.every(function (v) { return !v.available; });

    // ---------- botón (existente o creado) reubicado ARRIBA del ATC ----------
    var bisBtn = document.getElementById('bdg-bis-btn');
    if (!bisBtn) {
      bisBtn = document.createElement('button');
      bisBtn.type = 'button';
      bisBtn.id = 'bdg-bis-btn';
      bisBtn.className = 'button button--large bdg-bis-btn';
    }
    bisBtn.textContent = '📩 ' + BTN_TEXT;
    bisBtn.style.display = 'none';
    bisBtn.style.setProperty('margin', '0 0 10px', 'important');
    bisBtn.style.setProperty('width', '100%', 'important');
    atc.parentNode.insertBefore(bisBtn, atc);

    // ---------- modal (existente o creado) movido a <body> ----------
    var modal = document.getElementById('bdg-bis-modal');
    if (!modal) {
      modal = buildModal(productData.title || '');
      document.body.appendChild(modal);
      modal.querySelector('#bdg-bis-submit').addEventListener('click', function () {
        if (typeof window.bdgBisSubmit === 'function') { window.bdgBisSubmit(); } else { bisSubmit(); }
      });
      modal.querySelector('[data-bdg-bis-close]').addEventListener('click', function () {
        modal.style.display = 'none';
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') modal.style.display = 'none';
      });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) modal.style.display = 'none';
      });
    } else {
      // sacarlo de contenedores con transform/sticky que rompen position:fixed
      document.body.appendChild(modal);
      // alinear copys del modal server-rendered con los nuevos
      var ps = modal.querySelectorAll('p');
      if (ps[0]) ps[0].textContent = '📩 ' + MODAL_TITLE;
      if (ps[1]) ps[1].innerHTML = modalBodyHtml((productData && productData.title) || '');
      var submitBtn = modal.querySelector('#bdg-bis-submit');
      if (submitBtn) submitBtn.textContent = SUBMIT_TEXT;
    }

    bisBtn.onclick = function () { modal.style.display = 'flex'; };

    // ---------- estado según variante seleccionada ----------
    var bisSize = document.getElementById('bdg-bis-size');
    var currentOOS = false;

    // guard de submit: aunque el tema deje el botón activo, el form no envía
    form.addEventListener('submit', function (e) {
      if (currentOOS) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    function applyAtcState() {
      if (currentOOS) {
        atc.classList.add('button--sold-out');
        atc.style.setProperty('pointer-events', 'none', 'important');
        atc.style.setProperty('opacity', '0.55', 'important');
        atc.setAttribute('aria-disabled', 'true');
        var t = soldOutText();
        if (atc.textContent.trim() !== t) atc.textContent = t;
      } else {
        atc.style.removeProperty('pointer-events');
        atc.style.removeProperty('opacity');
        atc.removeAttribute('aria-disabled');
      }
    }

    function refresh() {
      var v = sel ? findVariant(sel.value) : null;
      if (!v && allOOS) v = variants[0];
      if (!v) { bisBtn.style.display = 'none'; return; }
      currentOOS = !v.available;
      bisBtn.style.display = currentOOS ? '' : 'none';
      bisBtn.setAttribute('data-variant-id', v.id);
      if (bisSize) bisSize.textContent = sizeLabel(v);
      applyAtcState();
    }

    function refreshDeferred() {
      // varias pasadas: theme.js reescribe el ATC de forma asíncrona
      setTimeout(refresh, 0);
      setTimeout(refresh, 250);
      setTimeout(refresh, 700);
    }

    if (sel) sel.addEventListener('change', refreshDeferred);
    // fallback: clicks en labels de talla (por si el tema no propaga change)
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-detail .opt-label')) {
        refreshDeferred();
      }
    });
    refresh();
    setTimeout(refresh, 600); // estado inicial tras arranque de theme.js
  }

  // definir el submit global solo si el inline de main-product no existe
  if (typeof window.bdgBisSubmit !== 'function') {
    window.bdgBisSubmit = bisSubmit;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
